import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {RectShape} from 'react-placeholder/lib/placeholders';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Typography,
	Button,
	Grid
} from '@material-ui/core';

import Constants from "../utils/Constants";
import TrendingTopicListItem from "./TrendingTopicListItem";
import ReportItemPaper from "../reports/components/ReportItemPaper";


const styles = makeStyles(theme => ({
	noActivity: {
		marginTop: "25%",
		textAlign: "center"
	},

	bold: {
		fontWeight: 700
	},

	cardWrapper: {
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "flex-start"
	}
}));

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const tablePlaceHolder = (
	<div style={{paddingBottom: 20, width: "100%"}}>
		<div style={{paddingTop: 20, display: "flex"}}>
			<RectShape style={{height: 50, width: 100}} color={placeholderColor}><span></span></RectShape>
			<RectShape style={{height: 50, marginRight: "0px !important"}} color={placeholderColor}><span></span></RectShape>
		</div>
		<div style={{paddingTop: 20, display: "flex"}}>
			<RectShape style={{height: 50, width: 100}} color={placeholderColor}><span></span></RectShape>
			<RectShape style={{height: 50, marginRight: "0px !important"}} color={placeholderColor}><span></span></RectShape>
		</div>
	</div>
);

function TrendsReportItem(props) {
	const [scrollTo, setScrollTo] = useState(null);
	const [selectedItem, setSelectedItem] = useState(null);

	let classes = styles(),
		{topics, fidoError, viewAllClickHandler, className, buttonClassName,
			topicClickHandler, national, topicToSelect, id} = props;

	const itemClicked = useCallback((topic) => {
		setSelectedItem(topic.id);
		topicClickHandler(topic);
	}, [setSelectedItem, topicClickHandler]);

	useEffect(() => {
		if (topicToSelect) {
			itemClicked({id: topicToSelect});

			let topicRow = document.querySelector(`[id='topic-${topicToSelect}']`);
			if (topicRow) {
				setScrollTo(topicRow.offsetTop);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ReportItemPaper
			taller
			id={id}
			role="group"
			aria-disabled="false"
			ready={topics != null}
			fidoError={fidoError}
			previousDays={30}
			placeHolder={tablePlaceHolder}
			scrollTo={scrollTo}
			className={`${topics && topics.length ? classes.cardWrapper : null} ${className}`}
			title={
				<div>
					<FontAwesomeIcon title="conversation bubbles" icon={["far", "comments-alt"]} /> Trending Topics
				</div>
			}>
			{topics && topics.length ?
				<React.Fragment>
					<Grid item xs={12}>
						<Grid container>
							{topics.map((topic, index) => {
								return (
									<Grid
										item
										xs={12}
										id={`topic-${topic.id}`}
										key={`key-${topic.id}`}>
										<TrendingTopicListItem
											national={national}
											topic={topic}
											topicNumber={++index}
											selected={selectedItem === topic.id || topicToSelect === topic.id}
											clickHandler={topicClickHandler ? () => itemClicked(topic) : null} />
									</Grid>
								);
							})}
						</Grid>
					</Grid>
					{viewAllClickHandler ?
						<Grid container justifyContent='flex-end' alignItems='center'>
						<Grid item>
						<Button
							color="primary"
							className={buttonClassName}
							endIcon={<FontAwesomeIcon icon={["fas", "envelope"]} />}
							onClick={viewAllClickHandler}>Go To Inbox</Button>
							</Grid></Grid> : null
					}
				</React.Fragment>
				:
				<Typography color="textSecondary" className={`${classes.noActivity}`}>
					There is no activity for this time period.
				</Typography>
			}
		</ReportItemPaper>
	);
}

TrendsReportItem.propTypes = {
	fidoError: PropTypes.bool,
	topics: PropTypes.array,
	previousDays: PropTypes.number,
	className: PropTypes.string,
	buttonClassName: PropTypes.string,
	viewAllClickHandler: PropTypes.func,
	topicClickHandler: PropTypes.func,
	national: PropTypes.bool,
	topicToSelect: PropTypes.number,
	id: PropTypes.string
};

export default TrendsReportItem;
